import { useCameraRouteParams } from "@src/hooks/useCameraRouteParams";
import { LivestreamContent, JpegStreamContent } from "@src/features/cameras/components";

export default function LivestreamScreen() {
  const { isLegacyAppCamera } = useCameraRouteParams({
    requireSiteId: false,
    requireCameraKey: true,
  });

  if (isLegacyAppCamera) {
    return <JpegStreamContent />;
  }

  return <LivestreamContent />;
}
